import React from 'react';
import { Card } from 'app/components/Card';
import { EquipmentInfo } from 'app/components/access-sharing';
import { IEquipmentEntry } from 'types/IEquipmentEntry';
import './EquipmentInfoCard.less';
import clsx from 'clsx';

interface Props {
  className?: string;
  equipment: IEquipmentEntry;
}

export default function EquipmentInfoCard({ equipment, className }: Props) {
  return (
    <Card className={clsx('equipment-info-card', className)}>
      <EquipmentInfo equipment={equipment} />
    </Card>
  );
}
